import { Button, PlusIcon, Text, TrashIcon } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { POSupplierProductListProps } from './po-additional-product-list.type'

import { DECIMAL_PLACES_DEFAULT } from '@/constants'
import type { GeneratePurchaseOrderPayloadAdditionalProductProps } from '@/types'

import styles from './po-additional-product-list.module.css'

export const POSupplierProductList = ({
  onSelectedProduct,
  onClickNewProduct,
  onClickRemoveProduct,
  additionalProductItems = [],
  title,
}: POSupplierProductListProps) => {
  const { t } = useTranslation('componentPOAdditionalProductList')

  const onHandleClickRemove = (
    event: React.MouseEvent<HTMLButtonElement>,
    productItem: Partial<GeneratePurchaseOrderPayloadAdditionalProductProps>,
  ) => {
    event.stopPropagation()

    onClickRemoveProduct(productItem)
  }

  return (
    <div className={styles.core}>
      <div className={styles['product-list-header']}>
        <Text variant="text-large-bold">{title}</Text>
        <Button variant="light" onClick={onClickNewProduct}>
          <PlusIcon /> {t('poAdditionalProductListButton')}
        </Button>
      </div>

      {additionalProductItems?.map((productItem, i) => (
        <button
          className={styles['product-item']}
          type="button"
          key={`${productItem?.catalogProductUuid}-${i}`}
          onClick={() => onSelectedProduct(productItem)}
        >
          <Text variant="title-base">
            {productItem?.catalogProduct?.attributes?.title}
          </Text>

          <div className={styles['product-item-row']}>
            <Text>
              <strong>{t('poAdditionalProductListItemQuantity')}:</strong>{' '}
              {productItem.quantity ? `${productItem.quantity} kg` : ' - '}
            </Text>
          </div>

          <Text>
            <strong>{t('poAdditionalProductListItemPrice')}:</strong>{' '}
            {productItem.cost ? Number(productItem?.cost).toFixed(DECIMAL_PLACES_DEFAULT) : ' - '}
          </Text>
          <Button
            variant="danger-light"
            model="square"
            className={styles['product-item-remove-button']}
            onClick={(event) => onHandleClickRemove(event, productItem)}
          >
            <TrashIcon />
          </Button>
        </button>
      ))}

      {additionalProductItems?.length === 0 && (
        <Text className={styles['no-product-message']}>
          {t('poAdditionalProductListEmpty')}
        </Text>
      )}
    </div>
  )
}
